import React from 'react'

const AppleIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='20'
      viewBox='0 0 16 20'
      fill='none'>
      <path
        d='M13.3621 10.6164C13.3375 8.12786 15.3919 6.93416 15.4832 6.87522C14.3288 5.18537 12.5309 4.95449 11.8903 4.92797C10.3606 4.77274 8.90463 5.82889 8.1275 5.82889C7.35332 5.82889 6.15471 4.95056 4.88536 4.97414C3.2191 4.99871 1.68154 5.94286 0.822866 7.4362C-0.910204 10.4425 0.378792 14.898 2.06765 17.3365C2.89292 18.5302 3.87735 19.8713 5.1693 19.8221C6.4131 19.773 6.8837 19.0175 8.38785 19.0175C9.89201 19.0175 10.3155 19.8231 11.632 19.7986C12.9711 19.773 13.8189 18.5813 14.6383 17.3847C15.5864 15.9994 15.9764 14.6583 16 14.5895C15.9705 14.5768 13.3886 13.5874 13.3631 10.6155L13.3621 10.6164ZM10.8882 3.31378C11.574 2.48163 12.0367 1.32723 11.91 0.175781C10.9226 0.21508 9.72499 0.834033 9.01663 1.66422C8.38098 2.40107 7.82392 3.57511 7.97325 4.70397C9.07558 4.79042 10.2015 4.14396 10.8882 3.31378Z'
        fill='black'
      />
    </svg>
  )
}

export default AppleIcon
